import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { SchoolViewModel } from "../../Screen/School/SchoolViewModel";
import { SchoolViewController, SchoolViewControllerDelegate } from "../../Screen/School/SchoolViewController";
import ProtectedRoute from '../../Components/ProtectedRoute';

export class SchoolCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, SchoolViewControllerDelegate {

    getRoute(): JSX.Element[]{
        return[
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element{
        var viewModel = new TableGenericViewModel("gepescolas")
        return (<ProtectedRoute requiredPermissions={['escolar.escolas.*']} path="/:base/escola" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'escolar.escolas.adicionar',
                    edit: 'escolar.escolas.editar',
                    delete: 'escolar.escolas.excluir',
                }}  
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Escola"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element{
        var viewModel = new SchoolViewModel()
        return (<ProtectedRoute requiredPermissions={['escolar.escolas.adicionar', 'escolar.escolas.editar']} path="/:base/escola/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<SchoolViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }
    
    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepescolas") {
            navigation.history.push(`escola/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepescolas") {
            navigation.history.push(`escola/cad/${idSelection}`);
            return;
        }
    }
}